module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_8023.c4cb57ad.png";